import React from 'react';

import Delivery from '../components/Delivery';

const DeliveryPage = () => {
  return <Delivery />;
};

export default DeliveryPage;
